import { SENTRY_DSN } from '@/config/env'

// Pluggable client error observability (amendment A3).
// No-op until a DSN is configured. When Sentry (or any sink) is wired, initialize it in
// initErrorReporting() and point `reporter` at it — no call sites change.

type Extra = Record<string, unknown>
type Reporter = (err: unknown, extra?: Extra) => void

let reporter: Reporter | null = null

export function initErrorReporting(): void {
  if (!SENTRY_DSN) return // disabled when unset
  // Intended wiring (out of scope until the DSN + dependency are added):
  //   import * as Sentry from '@sentry/react'
  //   Sentry.init({ dsn: SENTRY_DSN })
  //   reporter = (err, extra) => Sentry.captureException(err, { extra })
}

/** Register a custom reporter (used by tests / future Sentry init). */
export function setReporter(fn: Reporter | null): void {
  reporter = fn
}

export function captureError(err: unknown, extra?: Extra): void {
  // Always log so support can correlate via the request id, even with no external sink.
  // eslint-disable-next-line no-console
  console.error('[novitiq-admin]', err, extra ?? '')
  reporter?.(err, extra)
}

export interface ReportableApiError {
  status: number
  detail: string
  requestId?: string
}

/** Report an API failure, always carrying the echoed X-Request-ID for support correlation (A3). */
export function captureApiError(err: ReportableApiError, ctx?: Extra): void {
  captureError(new Error(`API ${err.status}: ${err.detail}`), {
    requestId: err.requestId ?? null,
    ...ctx,
  })
}
